export const GET_CUSTOMERS = '[Customer Action] Get customers';
export const CONFIRMED_GET_CUSTOMERS = '[Customer Action] Confirmed Get customers';
